module.exports = __webpack_public_path__ + "static/xl.db275b5b.png";